import { ErrorHandler, type Provider } from '@angular/core';

import { GlobalErrorHandler } from './global-error-handler';
import { provideValidationMessages } from './validation-messages';

export function provideErrorHandling(): Provider[] {
  return [{ provide: ErrorHandler, useClass: GlobalErrorHandler }, provideValidationMessages()];
}
